/**
 * Transhipment
 * @author ftgibran
 */
export enum Transhipment {
  DELIVERY = 1,
  RECEIPT = 2,
  DELIVERY_AND_RECEIPT = 3,
}
